import { useEffect, useState } from "react";
import Cookies from "universal-cookie";
import axios from "axios";
import Loader from "./loader";
import DataTable from "react-data-table-component";
import "bootstrap-icons/font/bootstrap-icons.css"; // Bootstrap Icons
import genratePdf from "./component/generatePdf";

function App() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rowsPerPageArea, setRowsPerPageArea] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentAreaPage, setCurrentAreaPage] = useState(1);

  const appURL = "https://hydrobharat.gov.in";
  const cookies = new Cookies();

  const path = window.location.pathname;
  const lastSegment = path.substring(path.lastIndexOf("/") + 1);

  const params = new URLSearchParams({
    client_id: "id-5e75518f-50b0-d798-cd87-47697def7a",
    client_secret: "secret-cbec6aa7-d95c-a9f7-748d-3a0e6289e8b",
    grant_type: "client_credentials",
  });

  useEffect(() => {
    const token = cookies.get("X-ACCESS-TOKEN");
    if (token) getWinsNavData(token);
    else getAuthToken();
  }, []);

  const getAuthToken = async () => {
    try {
      const res = await axios.post(`${appURL}/o/oauth2/token`, params, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Accept: "application/json",
        },
      });
      const token = res.data.access_token;
      cookies.set("X-ACCESS-TOKEN", token, {
        sameSite: "strict",
        path: "/",
        expires: new Date(new Date().getTime() + 86400000),
      });
      getWinsNavData(token);
    } catch (err) {
      setError("Failed to get token: " + err.message);
      setLoading(false);
    }
  };

  const getWinsNavData = async (token) => {
    try {
      const res = await axios.get(`${appURL}/o/nho-headless/map/combined`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const [{ NavTex }, { NavArea }] = res.data;

      const extractYearFromIdentifier = (identifier) => {
        if (!identifier) return new Date().getFullYear();
        const parts = identifier.split("/");
        if (parts.length < 2) return new Date().getFullYear();
        const yy = parseInt(parts[1]);
        return yy >= 0 && yy <= 99 ? 2000 + yy : new Date().getFullYear();
      };

      const addYear = (items) =>
        items.map((item) => ({
          ...item,
          year: extractYearFromIdentifier(item.identifier),
        }));

      const updatedNavTex = addYear(NavTex);
      const updatedNavArea = addYear(NavArea);

      setData({ NavTex: updatedNavTex, NavArea: updatedNavArea });
      setLoading(false);

      // Set default current year as max year in data
      const allYears = [
        ...updatedNavTex.map((i) => i.year),
        ...updatedNavArea.map((i) => i.year),
      ];
      const maxYear = Math.max(...allYears);
      setCurrentYear(maxYear);
    } catch (err) {
      if (err.response?.status === 401) getAuthToken();
      else {
        setError("Failed to fetch data: " + err.message);
        setLoading(false);
      }
    }
  };

  const removeSlashAndDigits = (str) => str.split("/")[0];

  const getUniqueYears = () => {
    const years = new Set();

    data?.NavTex?.forEach((item) => {
      if (item.year) years.add(item.year);
    });

    data?.NavArea?.forEach((item) => {
      if (item.year) years.add(item.year);
    });

    return [...years].sort((a, b) => b - a); // descending order
  };

  const filteredNavTex =
    data?.NavTex?.filter((item) => item.year === currentYear) || [];
  const filteredNavArea =
    data?.NavArea?.filter((item) => item.year === currentYear) || [];

  const from = filteredNavTex.length ? (currentPage - 1) * rowsPerPage + 1 : 0;
  const to = Math.min(from + rowsPerPage - 1, filteredNavTex.length);

  const fromArea = filteredNavArea.length
    ? (currentAreaPage - 1) * rowsPerPageArea + 1
    : 0;
  const toArea = Math.min(
    fromArea + rowsPerPageArea - 1,
    filteredNavArea.length
  );

  const handleYearChange = (year) => {
    setCurrentYear(year);
    setCurrentPage(1);
    setCurrentAreaPage(1);
  };

const viewButtonHandler = (data, type) => {
  const url = `https://hydrobharat.gov.in/india-wins?identifier=${encodeURIComponent(data.identifier)}&type=${encodeURIComponent(type)}`;
  window.open(url, '_blank');
};

  const actionButtons = (data,type) => (
    <div style={{ display: "flex" }}>
      <button
        title="View"
        onClick={() =>viewButtonHandler(data,type)}
        className="nav-action-btn"
      >
        <svg
          width="25"
          height="25"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8 3.5C4.75 3.5 2.015 5.4425 0.5 8.25C2.015 11.0575 4.75 13 8 13C11.25 13 13.985 11.0575 15.5 8.25C13.985 5.4425 11.25 3.5 8 3.5ZM8 11.125C6.2075 11.125 4.75 9.6675 4.75 7.875C4.75 6.0825 6.2075 4.625 8 4.625C9.7925 4.625 11.25 6.0825 11.25 7.875C11.25 9.6675 9.7925 11.125 8 11.125ZM8 6C7.035 6 6.25 6.785 6.25 7.75C6.25 8.715 7.035 9.5 8 9.5C8.965 9.5 9.75 8.715 9.75 7.75C9.75 6.785 8.965 6 8 6Z"
            fill="#fff"
          ></path>
        </svg>
      </button>
      <button
        title="Download"
        onClick={() => genratePdf(data,type)}
        className="nav-action-btn"
      >
        <svg xmlns="http://www.w3.org/2000/svg" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" image-rendering="optimizeQuality" fill-rule="evenodd" clip-rule="evenodd" viewBox="0 0 424 511.54" style={{ width: "30px",height: "35px"}}
    ><path fill="#fff" fill-rule="nonzero" d="M86.37 413.44c-11.76 0-11.76-17.89 0-17.89H189.1c-.2 2.95-.31 5.93-.31 8.94s.11 5.99.31 8.95H86.37zm35.31-167.09H104.5v19.96H78.08v-82.59h41.62c18.94 0 28.41 10.17 28.41 30.52 0 11.19-2.47 19.47-7.4 24.84-1.85 2.03-4.41 3.75-7.66 5.16-3.26 1.41-7.05 2.11-11.37 2.11zm-17.18-41.49v20.35h6.08c3.17 0 5.49-.33 6.94-.99 1.45-.66 2.18-2.18 2.18-4.56v-9.25c0-2.38-.73-3.9-2.18-4.56-1.45-.66-3.77-.99-6.94-.99h-6.08zm53.52 61.45v-82.59h37c14.89 0 25.11 3.17 30.66 9.51 5.55 6.34 8.32 16.94 8.32 31.78 0 14.85-2.77 25.44-8.32 31.78-5.55 6.34-15.77 9.52-30.66 9.52h-37zm37.4-61.45h-10.97v40.3h10.97c3.61 0 6.23-.41 7.86-1.25 1.63-.84 2.44-2.75 2.44-5.75v-26.3c0-2.99-.81-4.91-2.44-5.74-1.63-.84-4.25-1.26-7.86-1.26zm98.71 30.79h-22.47v30.66h-26.43v-82.59h54.18l-3.3 21.14h-24.45v11.1h22.47v19.69zM265.81 24.26v29.1c0 65.66 15.31 69.47 69.08 69.47h22.03l-91.11-98.57zm94.33 115.92h-21.48c-61.02 0-90.2-4.09-90.2-86.28V17.35H56.82c-21.7 0-39.47 17.78-39.47 39.47v264.79H219.2c-4.64 5.47-8.83 11.34-12.51 17.54H17.35v89.83c0 21.62 17.85 39.47 39.47 39.47h149.04c3.53 6.12 7.56 11.92 12.02 17.34H56.82C25.63 485.79 0 460.17 0 428.98V56.82C0 25.55 25.55 0 56.82 0h206.33a8.68 8.68 0 016.93 3.45l105.07 113.68c2.19 2.37 2.34 4.66 2.34 7.52v166.86c-5.55-2.98-11.35-5.56-17.35-7.71V140.18z"></path><path fill="red" d="M316.95 297.45c59.12 0 107.05 47.93 107.05 107.05 0 59.11-47.93 107.04-107.05 107.04S209.9 463.61 209.9 404.5c0-59.12 47.93-107.05 107.05-107.05z"></path><path fill="#fff" fill-rule="nonzero" d="M337.9 356.54l-3.77 47.75 17.35-6.07c11.47-4.4 23.27 3.72 14.38 13.82-10.82 12.45-27.26 29.55-39.22 40.94-7.43 7.42-11.73 7.49-19.18.06-13.24-13-26.24-27.44-39.18-40.87-9.25-10.06 2.3-18.55 14.28-13.95l17.16 6.01c-1.25-16.28-2.82-31.84-3.77-48.1 0-2.99 2.5-5.39 5.42-5.61 10.31 0 20.84-.24 31.12 0 2.92.22 5.42 2.62 5.42 5.61l-.01.41z"></path></svg>
      </button>
    </div>
  );

  return (
    <div className="App" style={{ padding: "20px" }}>
      {loading ? (
        <Loader />
      ) : (
        <div className="wins-nav">
          {error && <p style={{ color: "red" }}>{error}</p>}

          <div
            style={{
              display: "flex",
              gap: "10px",
              marginBottom: "20px",
              flexWrap: "wrap",
            }}
          >
            {getUniqueYears().map((year) => (
              <button
                key={year}
                onClick={() => handleYearChange(year)}
                className={`nav-year-btn ${
                  currentYear === year
                    ? "btn-primary-active-nav"
                    : "btn-primary-nav"
                }`}
              >
                {year}
              </button>
            ))}
          </div>

           {lastSegment == "navtex-warnings" ?
          <div className="navtex-data">
            <DataTable
              columns={[
                {
                  name: "Sr No.",
                  cell: (_row, index) =>
                    (currentPage - 1) * rowsPerPage + index + 1,
                  width: "80px",
                },
                {
                  name: "Identifier",
                  selector: (row) => removeSlashAndDigits(row.identifier),
                },
                { name: "Types", selector: (row) => row.types },
                { name: "Feature", selector: (row) => row.feature },
                {
                  name: "Message",
                  cell: (row) => (
                    <div dangerouslySetInnerHTML={{ __html: row.message }} />
                  ),
                  grow: 2,
                  width: "20rem",
                },
                { name: "Place", selector: (row) => row.place, width: "10rem" },
                {
                  name: "Action",
                  cell: (row) => actionButtons(row,"navTax"),
                  ignoreRowClick: true,
                },
              ]}
              data={filteredNavTex}
              pagination
              paginationPerPage={rowsPerPage}
              onChangePage={setCurrentPage}
              onChangeRowsPerPage={(newPerPage, page) => {
                setRowsPerPage(newPerPage);
                setCurrentPage(page);
              }}
              noDataComponent="No Navtex data available for this year."
            />
            <div className="result-count">
              Showing {from} to {to} of {filteredNavTex.length} entries
            </div>
          </div>
           : lastSegment == "navarea-warnings" ?
          <div className="navarea-data">
            <DataTable
              columns={[
                {
                  name: "Sr No.",
                  cell: (_row, index) =>
                    (currentAreaPage - 1) * rowsPerPageArea + index + 1,
                  width: "80px",
                },
                {
                  name: "Identifier",
                  selector: (row) => removeSlashAndDigits(row.identifier),
                },
                { name: "Types", selector: (row) => row.types },
                { name: "Feature", selector: (row) => row.feature },
                {
                  name: "Message",
                  cell: (row) => (
                    <div dangerouslySetInnerHTML={{ __html: row.message }} />
                  ),
                  grow: 2,
                  width: "20rem",
                },
                { name: "Place", selector: (row) => row.place, width: "10rem" },
                {
                  name: "Action",
                  cell: (row) => actionButtons(row,"navArea"),
                  ignoreRowClick: true,
                },
              ]}
              data={filteredNavArea}
              pagination
              paginationPerPage={rowsPerPageArea}
              onChangePage={setCurrentAreaPage}
              onChangeRowsPerPage={(newPerPage, page) => {
                setRowsPerPageArea(newPerPage);
                setCurrentAreaPage(page);
              }}
              noDataComponent="No Navarea data available for this year."
            />
            <div className="result-count">
              Showing {fromArea} to {toArea} of {filteredNavArea.length} entries
            </div>
          </div>
          :"No matching records available for this page at the moment."
            } 
        </div>
      )}
    </div>
  );
}

export default App;
